import { render } from "./MasterData.vue?vue&type=template&id=396a1810&scoped=true"
import script from "./MasterData.vue?vue&type=script&lang=js"
export * from "./MasterData.vue?vue&type=script&lang=js"

import "./MasterData.vue?vue&type=style&index=0&id=396a1810&scoped=true&lang=scss"

import exportComponent from "D:\\Pragmasoft\\zntry.consent\\src\\Zntry.Consent.Website\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-396a1810"]])

export default __exports__